// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__ZuEhw","EmbraceLogo":"styles_EmbraceLogo__gv2Nq"};